import React from "react";

const BackdropLoading = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/70 backdrop-blur-sm">
    <div className="flex flex-col items-center gap-3">
      <div className="w-10 h-10 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" />
      <p className="text-sm text-slate-300 font-medium">Cargando...</p>
    </div>
  </div>
);

export default BackdropLoading;
